export default {
  postureReport: "Informe de Postura",
  postureData: "Datos de Postura",
  postureDataContrast: "Contraste de Datos de Postura",
  postureRiskContrast: "Contraste de Riesgo de Postura",
  postureDataTrend: "Tendencia de Datos de Postura",
  postureRiskTrend: "Tendencia de Riesgo de Postura",
  postureLogData: "Datos de Registro de Postura",
  lateralhead: "Inclinación lateral de la cabeza",
  unevenshoulder: "Hombros desiguales",
  scoliosis: "Escoliosis",
  unevenhip: "Inclinación lateral de la pelvis",
  xleg: "Pierna en X",
  oleg: "Pierna en O",
  roundedshoulder: "Hombro redondeado",
  kneehyperextension: "Hiperextensión de la rodilla",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "Cabeza hacia adelante",
  toTheLeft: "(izquierda)",
  toTheRight: "(derecha)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(Normal)",
  leg: "Piernas",
  legLeft: "Piernas (L)",
  legRight: "Piernas (R)",
  riskAssessment: "Evaluación de Riesgo",
  muscleState: "Estado muscular",
  muscleStateDesc: "No se encontró ninguna condición muscular anormal",
  testTime: "Tiempo de Prueba",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Artículo",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Imagen moiré",
  lAbnormalRisk: "L Riesgo",
  mAbnormalRisk: "M Riesgo",
  hAbnormalRisk: "H Riesgo",
  highRisk: "Alto Riesgo",
  riskAnalysis: "Análisis de Riesgo",
  conclusionRecommendation: "Conclusión y Recomendación",
  solution: "Solución",
  movePosition: "Haga clic en el punto para mover la posición",
  confirmTheClose: "No guardado aún, ¿confirma el cierre?",
  closeInfo: "No guardado aún, ¿confirma el cierre?",
  share: "Compartir",
  front: "Frente",
  side: "Lado",
  back: "Atrás",
  otherSide: "Otro Lado",
  points: "Puntos",
  angle: "ángulo",
  name: "Nombre",
  gender: "Género",
  male: "masculino",
  female: "feminino",
  age: "Edad",
  year: "años",
  height: "Altura",
  weight: "Peso",
  time: "Tiempo",
  patientId: "ID del Paciente",
  save: "Guardar",
  saveModify: "Guardar Modificar",
  print: "Imprimir",
  cancel: "Cancelar",
  zoomIn: "Acercar",
  zoomOut: "Alejar",
  ok: "OK",
  return: "Atrás",
  empty: "",
  unknown: "desconocido",
  succeedToCopy: "Copiado con éxito",
  succeedToSave: "Guardado con éxito",
  headForwardDistance: "Distancia de cabeza hacia adelante",
  pelvisForwardTilt: "Inclinación pélvica hacia adelante",
  wristHipDistanceLeft: "Distancia muñeca a cadera (Izquierda)",
  wristHipDistanceRight: "Distancia de muñeca a cadera (derecha)",
  evaluator: "Evaluador",
  reportDate: "Fecha del informe",
  introduction: "Introducción",
  doctorIntroDefault: "Campo profesional: Medicina de rehabilitación, evaluación y corrección postural | Años de experiencia: más de 5 años | Especialidad: Rehabilitación de lesiones deportivas, corrección postural, manejo del dolor",
  recoveryLog: "Registro de Recuperación",
  returnToReport: "Volver al Informe",
  loading: "Cargando...",
  showToolbox: "Mostrar caja de herramientas",
  hideToolbox: "Ocultar caja de herramientas",
};

